export default "__VITE_ASSET__yOfBEsjk__"